<template>
  <v-container
    class="fill-height"
    fluid
    grey darken-4
    ref="contenedor"
  >
    <v-row
      align="center"
      justify="center"

    >
      <v-col
        cols="12"
        md="8"
      >
        <v-card
          class="pa-2 light-green darken-1"
          outlined         
          height= 400
        >
          <iframe
            class="frame"
            line-height="0"
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/jTa86LlC3lg?autoplay=1&mute=0&controls=0"
            frameborder="0"
            scrolling="no"
            marginheight="0"
            marginwidth="0"
            allow="autoplay"
          />
        </v-card>
        {{ user }}
      </v-col>
      
    </v-row>

  </v-container>
</template>

<script>
  export default {
    computed: {
      user () {
        return this.$store.getters.getUser
      },
    },
      
  }
</script>
